import styled from 'styled-components'

import { media, mediaMax } from 'styles/media'
import typeStyle from 'styles/typeStyle'

import { Card } from '../../../components/landing/Testimonials'
import CreateAListingIcon from '../../aboutStories/Host/iconography/CreateAListing'
import PublishAndPromoteIcon from '../../aboutStories/Host/iconography/PublishAndPromote'
import JoinIcon from '../../../components/icons/Join'

const organicSteps = [
  {
    heading: 'Join Riparide',
    text: 'With no joining fee, signing up as a host couldn’t be easier. We promise.',
    Illustration: JoinIcon,
  },
  {
    heading: 'Create your listing',
    text: 'Review our listing criteria, add your property details and tell us about any nearby outdoor adventures.',
    Illustration: CreateAListingIcon,
  },
  {
    heading: 'Welcome guests',
    text: 'Once your listing is published, the bookings will come and the guests will follow. Congrats!',
    Illustration: PublishAndPromoteIcon,
  },
]

const invitedSteps = [
  {
    heading: 'Check out your draft listing',
    text: 'We’ve been working hard to create a draft listing for your unique property. Take a look and get excited.',
    Illustration: JoinIcon,
  },
  {
    heading: 'Add extra details',
    text: 'Just add your cancellation policy, submit your payout details and sync your calendars. You’re almost ready to Riparide!',
    Illustration: CreateAListingIcon,
  },
  {
    heading: 'Welcome guests',
    text: 'Once your listing is published, the bookings will come and the guests will follow. Congrats!',
    Illustration: PublishAndPromoteIcon,
  },
]

const BorderlessCard = styled(Card)`
  border: 0;
  padding: 0;
  align-items: flex-start;

  ${media.md`
    align-items: center;
  `}

  ${media.xl`
    align-items: flex-start;
  `}

  ${mediaMax.md`
    width: unset;
    max-width: unset;
  `}
  
  svg {
    margin-bottom: 16px;
    width: 130px;
    height: 90px;

    ${media.md`
      margin-bottom: 32px;
    `}
  }
`

const Inner = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  ${media.md`
    margin: 0 auto;
    align-items: center;
    justify-content: center;
    text-align: center;
  `}

  ${media.xl`
    align-items: flex-start;
    flex-direction: row;
    text-align: left;
  `}

  ${BorderlessCard} {
    &:not(:last-child) {
      margin: 0 0 30px 0;

      ${media.md`
        margin: 0 30px 0 0;
      `}
    }
  }
`

const Heading = styled.h4`
  ${typeStyle('-ds-font-section-title-regular')}
  color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  margin-bottom: 0;
`

type HowItWorksStepsProps = {
  isInvited: boolean
}

const HowItWorksSteps = ({ isInvited }: HowItWorksStepsProps) => {
  const steps = isInvited ? invitedSteps : organicSteps

  return (
    <Inner>
      {steps.map(({ heading, text, Illustration }) => (
        <BorderlessCard key={heading}>
          <Illustration />
          <Heading>{heading}</Heading>
          <p>{text}</p>
        </BorderlessCard>
      ))}
    </Inner>
  )
}

export default HowItWorksSteps
